<template>
  <div>
    <v-app-bar class="text-center" :elevation="1">
      <v-app-bar-title>SUUQ</v-app-bar-title>
    </v-app-bar>

    <div class="d-flex align-center justify-center" style="height: 90vh">
      <v-card elevation="0" width="400" class="mx-auto mt-n3">
        <!-- Title -->
        <v-card-title class="text-center mb-5">
          Received your verification code?
          <div class="mt-3 text-caption">
            <span class="text-grey">Enter your verification code</span>
          </div>
        </v-card-title>

        <!-- OTP form + buttons -->
        <v-card-text>
          <v-form class="ma-3">
            <div class="mx-auto" style="max-width: 300px">
              <v-otp-input v-model="editedItem.otp" @finish="save" />
            </div>

            <v-btn
              :loading="loading"
              block
              color="error"
              size="large"
              class="mt-4"
              @click="save"
            >
              Submit
            </v-btn>

            <v-btn
              text
              block
              class="mt-2"
              :disabled="resending"
              @click="resend"
            >
              {{ resending ? "Resending…" : "Resend Code" }}
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<script>
import AuthService from "@/services/auth.service";
export default {
  data() {
    return {
      loading: false,
      resending: false,
      editedItem: { otp: "", email: "" },
    };
  },

  computed: {
    verificationEmail() {
      return localStorage.getItem("verification_email");
    },
  },

  methods: {
    // async save() {
    //   this.loading = true;
    //   this.editedItem.email = this.verificationEmail;
    //     console.log("itemm sent", this.editedItem.email);

    //   try {
    //     await AuthService.verifyUser(this.editedItem);
    //     this.$store.dispatch("alert/success", "Email verified! Please log in.");
    //     this.$router.push("/login");
    //   } catch (err) {
    //     this.$store.dispatch(
    //       "alert/error",
    //       err.response?.data?.message || err.message
    //     );
    //   } finally {
    //     this.loading = false;
    //   }

    // },

    async save() {
      // await this.$refs.form?.validate?.(); // if you have validation
      // if (this.valid?.valid === false) return; // mirror your login guard

      this.loading = true;
      try {
        // 1. Dispatch verifyUser instead of login
        const userData = await this.$store.dispatch("auth/verifyUser", {
          email: this.verificationEmail,
          otp: this.editedItem.otp,
        });

        // 2. Firebase authentication
        await this.$store.dispatch(
          "auth/firebaseAuth",
          userData.firebase_token
        );

        console.log("Login successful:", userData);

        // 3. Immediate route handling
        const redirectPath =
          userData.role?.slug === "admin"
            ? this.$route.query.redirect || "/admin"
            : this.$route.query.redirect || "/";

        this.$router.push(redirectPath);

        this.$store.dispatch("alert/success", "Login successful");
      } catch (error) {
        console.error("Login error:", error);
        this.$store.dispatch(
          "alert/error",
          error.response?.data?.message || error.message || "Login failed"
        );
        // Force cleanup if something partially succeeded
        await this.$store.dispatch("auth/logout");
      } finally {
        this.loading = false;
      }
    },

    async resend() {
      this.resending = true;
      this.editedItem.email = this.verificationEmail;
      console.log("itemmsss", this.editedItem.email);

      try {
        await AuthService.resendRegistrationOtp({
          email: this.editedItem.email,
        });
        this.$store.dispatch("alert/success", "A new code has been sent.");
      } catch (err) {
        this.$store.dispatch(
          "alert/error",
          err.response?.data?.message || err.message
        );
      } finally {
        this.resending = false;
      }
    },
  },
};
</script>
